import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MeetingsStatisticsAPI from '../../../api/MeetingsStatisticsAPI';
import { Badge } from '../../../components/Badge/Badge';

type Props = { timeRange: { start: string; end: string } };

function BookingsCancellationRatioCard({ timeRange }: Props) {
  const { t } = useTranslation();
  const [total, setTotal] = useState(0);
  const [cancelled, setCancelled] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await MeetingsStatisticsAPI.getBookingsCancellationRatio({ startTime: timeRange.start, endTime: timeRange.end });
        setTotal(res.data?.denominator || 0);
        setCancelled(res.data?.numerator || 0);
      } catch (e) {
        setTotal(0);
        setCancelled(0);
      }
    };
    fetchData();
  }, [timeRange.start, timeRange.end]);

  const percentage = total > 0 ? Math.round((cancelled / total) * 100) : 0;

  return (
    <div className="space-y-3">
      <div className="flex items-baseline justify-between">
        <span className="text-2xl font-bold text-foreground">{percentage}%</span>
        <Badge variant={percentage > 0 ? 'destructive' : 'secondary'} className="text-xs">
          {t('stats.cancelled') || 'Cancelled'}
        </Badge>
      </div>
      <p className="text-sm text-muted-foreground">
        {t('stats.cancelled_vs_total', { cancelled, total }) || `${cancelled} cancelled of ${total} bookings`}
      </p>
    </div>
  );
}

export default BookingsCancellationRatioCard;


